import { ChangeDetectorRef, Component, OnInit ,Inject} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { NgClass, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'meet-the-team',
  standalone: true,
  imports: [MatIconModule,FuseCardComponent,NgStyle, NgClass, RouterLink,MatTooltipModule,MatDialogModule],
  templateUrl: './team.component.html',
  styleUrl: './team.component.scss'
})
export class TeamModalComponent implements OnInit {
  

  public view: any = {
  }
  openModal() {
  }
  closeModal() {
    this.dialogRef.close();
  }
  constructor(public dialogRef: MatDialogRef<TeamModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }
  ngOnInit(): void {
  }
}

